import { Task } from 'Service/models/Task'
import { AsyncService } from 'Service/services/AsyncService'
import { TaskStatusEnum } from 'Service/models/TaskStatusEnum'

export class AsyncApiError extends Error {
  public readonly statusText: string
  public readonly body: any

  constructor(response: Task, message: string) {
    super(message)

    this.name = 'AsyncApiError'
    this.statusText = response.status
    this.body = response.result
  }
}

type PoolOptions = {
  poolIntervalTime?: number
}

function getPollIntervalTime(poolCount: number, overrideIntervalTime?: number) {
  /*
  If overrideIntervalTime is provided, return the same as the time interval 
  between pooling requests
  */
  if (overrideIntervalTime) return overrideIntervalTime * 1000

  // Default behaviour
  if (poolCount < 5) return 2000
  else if (poolCount < 10) return 5000
  else return 8000
}

function pollTaskStatus(taskId: string, options: PoolOptions = {}): Promise<any> {
  let pollCount = 0
  const failureStatusCode: TaskStatusEnum = 'FAILURE'
  return new Promise((resolve, reject) => {
    const checkTaskStatus = () => {
      pollCount++
      AsyncService.asyncStatusRetrieve({ taskId, _delete: true })
        .then((response) => {
          // Exit polling if failure status code is received
          if (response.status == failureStatusCode) {
            reject(new AsyncApiError(response, 'Task unsuccessfull'))
          }
          // Return response if success is received
          else if (response.status === 'SUCCESS') {
            resolve(response.result)
          }
          // Retry in all other scenarios
          else {
            setTimeout(checkTaskStatus, getPollIntervalTime(pollCount, options?.poolIntervalTime))
          }
        })
        .catch(() =>
          setTimeout(checkTaskStatus, getPollIntervalTime(pollCount, options?.poolIntervalTime))
        )
    }
    setTimeout(checkTaskStatus, getPollIntervalTime(pollCount, options?.poolIntervalTime))
  })
}

export default pollTaskStatus
